"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventbriteAuthorizeUrlDto = exports.EventbriteStatusDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class EventbriteStatusDto {}
exports.EventbriteStatusDto = EventbriteStatusDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], EventbriteStatusDto.prototype, "connected", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Primary email of the connected Eventbrite account.'
}), __metadata("design:type", Object)], EventbriteStatusDto.prototype, "eventbriteEmail", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'When the Eventbrite orders were last pulled.'
}), __metadata("design:type", Object)], EventbriteStatusDto.prototype, "lastSyncedAt", void 0);
class EventbriteAuthorizeUrlDto {}
exports.EventbriteAuthorizeUrlDto = EventbriteAuthorizeUrlDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Eventbrite consent page to open in a browser; it redirects back to the backend callback.'
}), __metadata("design:type", String)], EventbriteAuthorizeUrlDto.prototype, "url", void 0);
//# sourceMappingURL=EventbriteAccount.dto.js.map